/** Event name registered server-side in the `/event` allow-list. */
export const GREETING_AUDIO_EVENT_NAME = "greeting_audio";
